/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ApiKey } from './ApiKey.js';
import {
    ApiKeyFromJSON,
    ApiKeyFromJSONTyped,
    ApiKeyToJSON,
} from './ApiKey.js';

/**
 * 
 * @export
 * @interface GetApiKeysResponse
 */
export interface GetApiKeysResponse {
    /**
     * 
     * @type {Array<ApiKey>}
     * @memberof GetApiKeysResponse
     */
    data?: Array<ApiKey>;
    /**
     * 
     * @type {number}
     * @memberof GetApiKeysResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetApiKeysResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetApiKeysResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetApiKeysResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetApiKeysResponse interface.
 */
export function instanceOfGetApiKeysResponse(value: object): boolean {
    return true;
}

export function GetApiKeysResponseFromJSON(json: any): GetApiKeysResponse {
    return GetApiKeysResponseFromJSONTyped(json, false);
}

export function GetApiKeysResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetApiKeysResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ApiKeyFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetApiKeysResponseToJSON(value?: GetApiKeysResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ApiKeyToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

